module.exports = __webpack_public_path__ + "static/media/bon.8584cffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/bon.jpg
// module id = 721
// module chunks = 0